import validate from "/usr/src/app/content/n3-redirections-service-974853cc-ff48-402e-8485-282b90218cea/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-service-974853cc-ff48-402e-8485-282b90218cea/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}